export default __webpack_public_path__ + "static/media/tag_icon.3f3d782c.svg";